import './CategoryBanner.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

import Picture from '@/common/components/atoms/Picture/Picture';
import { ROUTE_NODES_CATEGORY } from '@/common/constants';
import useImage from '@/common/hooks/image/useImage';
import capitalizeFirstLetter from '@/common/utils/caseUtils';
import clearance from '@/ebat/assets/banners/clearance.jpg';
import discount from '@/ebat/assets/banners/discount.jpg';
import exclusivity from '@/ebat/assets/banners/exclusivity.jpg';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

import {
  CategoryBannerDefaultProps,
  CategoryBannerPropTypes,
} from './CategoryBanner.proptypes';

const CategoryBanner = ({
  categoryName,
  className,
  categoryFromBack,
  image,
  upperCategory,
  upperCategorySlug,
  url,
}) => {
  const { t } = useTranslation();

  const { alt, src } = useImage({
    image,
    format: PRODUCTS_TYPES_FORMATS.MOSAIC,
  });

  const banners = {
    clearance,
    discount,
    exclusivity,
  };

  return (
    <div
      className={cn('category-banner__offers', className, {
        'category-banner__offers--url': url,
      })}
      style={{
        backgroundImage: url ? `url(${url})` : `url(${banners[categoryName]})`,
      }}
    >
      <div className="category-banner__wrapper">
        {upperCategory && (
          <NavLink
            className="h3 category-banner__upper-category"
            to={`${ROUTE_NODES_CATEGORY}/${upperCategorySlug}`}
          >
            {capitalizeFirstLetter(upperCategory?.toLowerCase())}
          </NavLink>
        )}
        <div className="category-banner__title-container">
          {image && (
            <Picture alt={alt} className="category-banner__image" src={src} />
          )}
          <p className="h1 category-banner__title" data-qa-id="title">
            {categoryFromBack
              ? capitalizeFirstLetter(categoryName?.toLowerCase())
              : t(`ebat:entities:offers_category.title.${categoryName}`)}
          </p>
        </div>
      </div>
    </div>
  );
};

CategoryBanner.defaultProps = {
  ...CategoryBannerDefaultProps,
};

CategoryBanner.propTypes = {
  ...CategoryBannerPropTypes,
};

export default CategoryBanner;
